import { render } from "./PrescriberProfileDetails.vue?vue&type=template&id=da9584bc&scoped=true"
import script from "./PrescriberProfileDetails.vue?vue&type=script&lang=js"
export * from "./PrescriberProfileDetails.vue?vue&type=script&lang=js"

import "./PrescriberProfileDetails.vue?vue&type=style&index=0&id=da9584bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9584bc"]])

export default __exports__